import ForumGate from "./components/ForumGate";
import ForumThreadsPage from "./pages/ForumThreadsPage";
import ForumThreadPage from "./pages/ForumThreadPage";
import NewThreadPage from "./pages/NewThreadPage";
import ForumMembersPage from "./pages/ForumMembersPage";

/**
 * The National Policy Committee's closed forum.
 *
 * No `roles` or `perms` here, and that is not an oversight. Membership of
 * this committee is not a spatie role anybody is granted — it is a
 * consequence of the national office a person holds today, spread across the
 * national positions register and the chapter leadership register. There is
 * no fixed role name a route guard could name, and inventing one would mean
 * keeping a second copy of the membership in sync with the first.
 *
 * So the route is open to any signed-in user and ForumGate asks the server
 * — which is where the real gate lives anyway: every endpoint these pages
 * call sits behind the `policy.committee` middleware. A non-member who types
 * the URL gets the explanation screen; if they got past it somehow, they
 * would get 403s and an empty page.
 */
const gated = (element: React.ReactNode) => <ForumGate>{element}</ForumGate>;

export const forumRoutes = [
  { path: "/forum", element: gated(<ForumThreadsPage />) },
  { path: "/forum/new", element: gated(<NewThreadPage />) },
  { path: "/forum/members", element: gated(<ForumMembersPage />) },
  { path: "/forum/:id", element: gated(<ForumThreadPage />) },
];
